import {GET_ALL_STAFF_SUPPORT,GET_STAFF_SUPPORT_DATA,GET_ALL_REPLY} from "./actions";

const initialState={
    staffSupport:{
        docs:[],
        totalDocs:0,
        limit:10,
        page:1,
        totalPages:0,
        paginCounter:0,
        hasPrevPage:false,
        hasNextPage:false,
        prevPage:null,
        nextPage:null,
    },
    getStaffSupportData:{},
    getReplyData:{},
    loading:true,
};

const staffSupportReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case GET_ALL_STAFF_SUPPORT:
            return {
                ...state,
                loading:false,
                staffSupport:payload,
            };
        case GET_STAFF_SUPPORT_DATA:
            return {
                ...state,
                loading:false,
                getStaffSupportData:payload,
            }
        case GET_ALL_REPLY:
            return {
                ...state,
                loading:false,
                getReplyData:payload,
            }
        default:
            return state;
    }
}

export default staffSupportReducer;